// extracted by mini-css-extract-plugin
module.exports = {"vbUiBtnDanger":"_1dLae__vbUiBtnDanger _275fm__vbUiBtn"};